import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import AppLifecycleLog from './app-lifecycle-log';
import { CustomLoggerService } from '../../custom-logging/custom-logger.service';

const NATIVE_LOG_PREFIX = 'NATIVE_LIFECYCLE_LOG';

/**
 * Cold start, background and destroy happen while the webview is gone, so the native plugin
 * buffers them. This drains that buffer into the custom logger whenever the webview is alive.
 */
@Injectable({ providedIn: 'root' })
export class AppLifecycleLogService {
  constructor(private customLogger: CustomLoggerService) {}

  isSupported(): boolean {
    return Capacitor.isNativePlatform();
  }

  /** Clears the buffer only after the entries are handed to the logger, so nothing is lost. */
  async syncLogs(): Promise<void> {
    if (!this.isSupported()) return;

    try {
      const { logs } = await AppLifecycleLog.getLogs();
      if (!logs?.length) return;

      logs.forEach((log) => this.customLogger.log(`${NATIVE_LOG_PREFIX}: ${log}`));
      await AppLifecycleLog.clearLogs();
    } catch (error) {
      this.customLogger.log('Failed to sync native lifecycle logs', JSON.stringify(error));
    }
  }
}
